export interface Service {
  num: string;
  title: string;
  desc: string;
  delay: number;
}

export interface IndustryFeature {
  title: string;
  desc: string;
}

export interface Industry {
  id: string;
  name: string;
  blurb: string;
  delay: number;
  features: IndustryFeature[];
}

export const marquee = [
  'Software Development',
  'API Development',
  'DevOps',
  'Team Building',
  'Project Management',
  'Mentoring'
];

export const services: Service[] = [
  {
    num: '01',
    title: 'Software Development',
    desc: 'Custom software with a focus on correctness, reliability, scalability, and business outcomes.',
    delay: 0
  },
  {
    num: '02',
    title: 'API Development',
    desc: 'Reliable, well-documented APIs that integrate seamlessly with your existing systems.',
    delay: 60
  },
  {
    num: '03',
    title: 'DevOps Integration',
    desc: 'Infrastructure as Code, automated CI/CD pipelines, containerisation and multi-cloud deployments for maximum operational efficiency.',
    delay: 120
  },
  {
    num: '04',
    title: 'Team Training & Mentoring',
    desc: 'Training and mentoring for development teams to sharpen technical expertise and deliver better outcomes.',
    delay: 180
  },
  {
    num: '05',
    title: 'Project Management',
    desc: 'End-to-end project management with experienced teams that build and deliver complete solutions.',
    delay: 240
  },
  {
    num: '06',
    title: 'Team Building',
    desc: 'We can build, staff and run entire projects — a complete solution tailored to your business needs.',
    delay: 300
  }
];

export const industries: Industry[] = [
  {
    id: 'shipbroking',
    name: 'Shipbroking & Maritime',
    blurb: 'Deep familiarity with the challenges of shipbroking, built alongside several maritime clients.',
    delay: 0,
    features: [
      {
        title: 'Industry Expertise',
        desc: 'We understand the unique challenges of shipbroking, with experience developing solutions for several clients in the sector.'
      },
      {
        title: 'Custom Analytics',
        desc: 'Tailored analytics that turn shipping and market data into actionable insight.'
      },
      {
        title: 'Integration Solutions',
        desc: 'Seamless integration with maritime systems, databases and third-party services — including accountancy software like Xero.'
      },
      {
        title: 'Specialised Tools',
        desc: 'Vessel tracking, freight calculations, contract management and other shipbroking-specific tooling.'
      },
      {
        title: 'Device Management',
        desc: 'Device management with tools like InTune to keep machines and mobile devices secure.'
      },
      {
        title: 'IT Services',
        desc: 'General IT support and services tailored to the needs of maritime businesses.'
      }
    ]
  },
  {
    id: 'media',
    name: 'Media Services',
    blurb: 'Solutions for demanding video and metadata workflows where quality and speed both matter.',
    delay: 100,
    features: [
      {
        title: 'Media Transformation',
        desc: 'Advanced video and metadata transformation workflows for optimal quality and delivery across your pipeline.'
      },
      {
        title: 'Transcoding Workflows',
        desc: 'Expert management of complex transcoding workflows, integrating with your existing tools for quality control.'
      },
      {
        title: 'Workflow Optimisation',
        desc: 'Streamlined file delivery built for speed, accuracy and reliability in demanding media environments.'
      }
    ]
  },
  {
    id: 'startups',
    name: 'Startup Acceleration',
    blurb: 'Pragmatic engineering for teams that need to move fast without painting themselves into a corner.',
    delay: 200,
    features: [
      {
        title: 'Velocity-Driven Development',
        desc: 'Rapidly build and iterate on MVPs, making technical decisions that win now and hold up as you grow.'
      },
      {
        title: 'Technical Strategy',
        desc: 'Guidance that balances immediate market needs with long-term scalability and tech-debt management.'
      },
      {
        title: 'Flexible Architecture',
        desc: 'Systems that adapt to evolving requirements while staying stable and performant.'
      },
      {
        title: 'Startup Navigation',
        desc: 'We know the realities of startups — constraints, pivots — and deliver solutions that maximise impact.'
      },
      {
        title: 'Time-to-Market Focus',
        desc: 'Processes optimised to ship features quickly without sacrificing quality and reliability.'
      }
    ]
  }
];
